<template>
  <div class="random-rewards-bind_bound">
    <template v-if="cardCodeHidden">
      <div class="random-rewards_bound-picture">
        <div
          :class="[
            'card-picture',
            'card-picture__preview',
            tag ? `card-picture__tag-${tag.toLowerCase()}` : undefined,
            `card-picture__type-${pictureType}`,
          ]" />
      </div>
      <div class="random-rewards-bind_binded-description">
        <div class="random-rewards-bind_bound-description-head">{{ $c('Привязанная карта') }}</div>
        <div class="random-rewards-bind_bound-description-card" v-html="$c(cardCodeHidden, {mark_start: '<b>', mark_end: '</b>'})" />
      </div>
    </template>
    <template v-else>
      <div class="random-rewards_bound-picture">
        <div class="random-rewards_bound-picture-blank"></div>
      </div>
      <div class="random-rewards-bind_binded-description">
        <div class="random-rewards-bind_bound-description-head">{{ $c('Карта еще не привязана') }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import { CARD_TYPES_BY_GAMES, UNKNOWN_CARD_TYPE } from '@/constants'
const randomRewards = namespace('randomRewards')

@Component({})
class BoundCard extends Vue {
  @randomRewards.State('cardCodeHidden') cardCodeHidden
  @randomRewards.State('cardType') cardType
  @randomRewards.State('tag') tag
  @State('randomButtonData') randomButtonData
  @State('country') currentCountry

  get pictureType () {
    if (this.cardType && this.cardType !== UNKNOWN_CARD_TYPE) {
      return this.cardType
    }
    const game = this.randomButtonData.game
    return CARD_TYPES_BY_GAMES[game][0]
  }
}
export default BoundCard
</script>

<style lang="scss">
.random-rewards_bound-picture {
  width: 95px;
  margin-right: 24px;
}
.random-rewards_bound-picture-blank {
  width: 100%;
  height: 60px;
  border: 2px dashed #ffffff;
  opacity: .3;
  border-radius: 3px;
}
.random-rewards-bind_bound-description-card {
  b {
    color: #ffffff;
    font-weight: normal;
  }
}
</style>
